var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-graph',{staticClass:"past-months-bar-graph",class:{ 'out-of-date': _vm.outOfDate },attrs:{"graph-height":_vm.graphHeight,"bar-values":_vm.barValues}})}
var staticRenderFns = []

export { render, staticRenderFns }